import { Stack, LinearProgress } from '@mui/material';

const ClientLinearBar = ({ value, barHeight, color, bg }) => (
  <Stack mt={2} width="100%" alignItems="center">
    <LinearProgress
      variant="determinate"
      value={value}
      sx={{
        width: '100%',
        maxWidth: '1000px',
        height: barHeight,
        borderRadius: 4,
        backgroundColor: `${bg} !important`,
        background : `${bg} !important`,
        '& .MuiLinearProgress-bar': {
          background: color ,
        },
      }}
    />
  </Stack>
);

export default ClientLinearBar;
